<template>
  <link rel="stylesheet" href="https://fonts.googleapis.com/icon?family=Material+Icons" />
  <link href="https://stackpath.bootstrapcdn.com/bootstrap/4.5.0/css/bootstrap.min.css" rel="stylesheet" />
  <link rel="stylesheet" href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@24,400,0,0" />
  <div>
    <!-- Breadcrumb y ayuda -->
    <div class="mb-3">
      <div class="row">
        <div class="col-11">
          <div class="breadcrumb-container">
            <a href="javascript:void(0)" @click="irAPlanillaPopup(datoPlanillaDet.idPlanilla)">
              Planilla {{ datoPlanillaDet.planillaNumero }}
            </a> > Registro de Observaciones
          </div>
        </div>
        <div class="col-1">
          <span
            class="material-symbols-outlined"
            style="font-size: 32px; color: blue; cursor: pointer"
            @click="showModalHelp = true"
          >help</span>
        </div>
      </div>
    </div>
    <Modal v-model:modelValue="showModalHelp">
      <AyudaTramiteForm />
    </Modal>
    <hr />

    <!-- Master -->
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <form>
          <div class="modal-body">
            <div class="mb-3">
              <div class="row">
                <div class="col-2"><label class="form-label fw-bold">Nombre</label></div>
                <div class="col-4"><span>{{ datoPlanillaDet.planillaNombre }}</span></div>
                <div class="col-2"><label class="form-label fw-bold">Cédula</label></div>
                <div class="col-4"><span>{{ datoPlanillaDet.planillaCedula }}</span></div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2"><label class="form-label fw-bold">Elemento TPSNS</label></div>
                <div class="col-10">
                  <span>{{ datoPlanillaDet.elementoCodigo }} - {{ datoPlanillaDet.elementoNombre }}</span>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2"><label class="form-label fw-bold">Descripción</label></div>
                <div class="col-10">
                  <span class="text-uppercase">{{ datoPlanillaDet.descripcion }}</span>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2"><label class="form-label fw-bold">Cantidad</label></div>
                <div class="col-4"><span class="text-uppercase">{{ datoPlanillaDet.cantidad }}</span></div>
                <div class="col-2"><label class="form-label fw-bold">Valor Unitario</label></div>
                <div class="col-4"><span class="text-uppercase">{{ datoPlanillaDet.valorUni }}</span></div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>

    <!-- Barra de acciones -->
    <div class="row g-2 align-items-center mb-3">
      <div class="col-auto">
        <button
          type="button"
          class="btn btn-outline-secondary btn-sm d-flex align-items-center gap-1"
          @click="getDataPaginaTodos(1)"
          title="Recargar todos los registros"
        >
          <span class="material-icons" style="font-size:16px">refresh</span> Todos
        </button>
      </div>
      <div class="col-auto ms-auto d-flex align-items-center gap-2" v-if="pladetobss.length > 0">
        <label class="form-label mb-0 small fw-bold">Mostrar</label>
        <select
          v-model.number="elementosPorPagina"
          class="form-select form-select-sm"
          style="width:75px"
          @change="aplicarPaginacion(1)"
        >
          <option :value="10">10</option>
          <option :value="25">25</option>
          <option :value="50">50</option>
          <option :value="100">100</option>
        </select>
        <span class="small text-muted">registros</span>
      </div>
      <div class="col-auto" v-if="p_procesoAM == 1">
        <button
          type="button"
          class="btn btn-outline-success btn-sm d-flex align-items-center gap-1"
          @click="abrirModalCrear"
          title="Registrar observaciones"
        >
          <span class="material-icons" style="font-size:16px">add_box</span>
          Registrar observaciones
        </button>
      </div>
    </div>

    <!-- Tabla -->
    <div class="table-responsive" v-if="pladetobss.length > 0">
      <table id="sampleTable" class="table table-hover table-bordered table-sm">
        <thead class="table-dark">
          <!-- Fila de encabezados -->
          <tr>
            <th></th>
            <th class="th-sort" @click="ordenarPor('observacionDescripcion')">
              Obs. Estándar <span>{{ iconOrden('observacionDescripcion') }}</span>
            </th>
            <th class="th-sort" @click="ordenarPor('descripcion')">
              Obs. Complementaria <span>{{ iconOrden('descripcion') }}</span>
            </th>
            <th v-if="p_procesoAM == 1"></th>
          </tr>
          <!-- Fila de filtros -->
          <tr>
            <th></th>
            <th>
              <input
                v-model="filtroObsEstandar"
                @input="aplicarPaginacion(1)"
                class="form-control form-control-sm"
                placeholder="Filtrar..."
              />
            </th>
            <th>
              <input
                v-model="filtroDescripcion"
                @input="aplicarPaginacion(1)"
                class="form-control form-control-sm"
                placeholder="Filtrar..."
              />
            </th>
            <th v-if="p_procesoAM == 1"></th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="pladetobs in datosPaginados"
            :key="pladetobs.idPlaDetObs"
            title="Doble clic para editar"
            @dblclick="abrirModalEditar(pladetobs.idPlaDetObs)"
          >
            <td>
              <i
                class="material-icons"
                style="font-size: 16px; color: orangered; cursor: pointer"
                @click="abrirModalEditar(pladetobs.idPlaDetObs)"
                title="Editar"
              >edit_square</i>
            </td>
            <td>{{ pladetobs.observacionDescripcion }}</td>
            <td>{{ pladetobs.descripcion }}</td>
            <td v-if="p_procesoAM == 1">
              <i
                class="material-icons"
                style="font-size: 16px; color: red; cursor: pointer"
                @click="deletePlaDetObs(pladetobs.idPlaDetObs)"
                title="Borrar"
              >delete</i>
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr class="table-secondary">
            <td :colspan="p_procesoAM == 1 ? 4 : 3" class="text-end fw-bold small">
              Mostrando {{ datosPaginados.length }} de {{ pladetobsOrdenados.length }} registros
            </td>
          </tr>
        </tfoot>
      </table>
    </div>

    <!-- Sin resultados -->
    <div v-if="sinResultados" class="alert alert-warning mt-3" role="alert">
      No se recuperaron registros.
    </div>

    <!-- Paginación -->
    <div
      class="d-flex justify-content-between align-items-center mt-3"
      v-if="pladetobss.length > 0"
    >
      <span class="small text-muted">
        Página {{ paginaActual }} de {{ totalPaginas() }} — {{ pladetobsOrdenados.length }} registros
      </span>
      <nav aria-label="Paginación">
        <ul class="pagination pagination-sm mb-0">
          <li class="page-item" :class="{ disabled: paginaActual === 1 }">
            <a class="page-link" href="#" @click.prevent="aplicarPaginacion(1)">«</a>
          </li>
          <li class="page-item" :class="{ disabled: paginaActual === 1 }">
            <a class="page-link" href="#" @click.prevent="getPreviousPage">‹</a>
          </li>
          <li
            v-for="pagina in paginasVisibles"
            :key="pagina"
            class="page-item"
            :class="{ active: pagina === paginaActual, disabled: pagina === '...' }"
          >
            <a
              class="page-link"
              href="#"
              @click.prevent="pagina !== '...' && aplicarPaginacion(pagina)"
            >{{ pagina }}</a>
          </li>
          <li class="page-item" :class="{ disabled: paginaActual === totalPaginas() }">
            <a class="page-link" href="#" @click.prevent="getNextPage">›</a>
          </li>
          <li class="page-item" :class="{ disabled: paginaActual === totalPaginas() }">
            <a class="page-link" href="#" @click.prevent="aplicarPaginacion(totalPaginas())">»</a>
          </li>
        </ul>
      </nav>
    </div>

    <!-- Modal -->
    <div
      class="modal fade"
      id="ventanaModal"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      :aria-hidden="isModalOpen ? 'false' : 'true'"
      v-if="modalWindow"
    >
      <div class="modal-dialog modal-xl">
        <div class="modal-content">
          <div class="modal-header bg-primary">
            <span class="material-icons" style="font-size:24px; color:white">info</span>
            <h5 class="modal-title text-white" id="exampleModalLabel">{{ titulo }}</h5>
            <button
              type="button"
              class="btn-close btn-close-white"
              data-bs-dismiss="modal"
              aria-label="Close"
              @click="cerrarModal"
            ></button>
          </div>
          <form>
            <div class="modal-body">
              <!-- SELECTOR DE OBSERVACIÓN ESTÁNDAR -->
              <div class="obs-selector-card mb-3">
                <div class="obs-selector-header">
                  <span class="obs-selector-title">
                    <i class="material-icons obs-icon">search</i>
                    Observación Estándar
                  </span>
                  <span class="obs-count-badge">
                    {{ observacionesFiltradas.length }} resultado{{ observacionesFiltradas.length !== 1 ? 's' : '' }}
                  </span>
                </div>
                <!-- Barra de búsqueda -->
                <div class="obs-search-bar">
                  <i class="material-icons obs-search-icon">manage_search</i>
                  <input
                    type="text"
                    class="obs-search-input"
                    v-model="filtroObservaciones"
                    placeholder="Buscar observación por descripción..."
                    @input="onFiltroInput"
                    @focus="mostrarLista = true"
                    autocomplete="off"
                  />
                  <button
                    v-if="filtroObservaciones"
                    type="button"
                    class="obs-clear-btn"
                    @click="limpiarFiltroObservaciones"
                    title="Limpiar"
                  >
                    <i class="material-icons" style="font-size:18px">close</i>
                  </button>
                </div>
                <!-- Preview de selección -->
                <div v-if="observacionSeleccionada" class="obs-selected-preview">
                  <i class="material-icons" style="font-size:16px;color:#0d6efd">check_circle</i>
                  <span class="obs-selected-text">{{ observacionSeleccionada.descripcion }}</span>
                </div>
                <!-- Lista de resultados -->
                <div
                  v-if="mostrarLista && observacionesFiltradas.length > 0"
                  class="obs-results-list"
                >
                  <div
                    v-for="obs in observacionesFiltradas"
                    :key="obs.idObservacion"
                    class="obs-result-item"
                    :class="{ 'obs-result-item--selected': datoPlaDetObs.idObservacion === obs.idObservacion }"
                    @click="seleccionarObservacion(obs)"
                  >
                    <div class="obs-result-desc">
                      <span v-html="resaltarTexto(obs.descripcion, filtroObservaciones)"></span>
                    </div>
                    <div v-if="datoPlaDetObs.idObservacion === obs.idObservacion" class="obs-result-check">
                      <i class="material-icons" style="font-size:18px;color:#0d6efd">check</i>
                    </div>
                  </div>
                </div>
                <!-- Sin resultados -->
                <div v-else-if="mostrarLista && observacionesFiltradas.length === 0" class="obs-empty">
                  <i class="material-icons" style="font-size:32px;color:#adb5bd">search_off</i>
                  <p>No se encontraron observaciones para "<strong>{{ filtroObservaciones }}</strong>"</p>
                </div>
              </div>

              <!-- Observación Complementaria -->
              <div class="mb-3">
                <div class="row">
                  <div class="col-11">
                    <label for="descripcion" class="form-label">Observación Complementaria</label>
                    <textarea
                      class="form-control"
                      id="descripcion"
                      name="descripcion"
                      v-model="datoPlaDetObs.descripcion"
                      style="text-transform: uppercase"
                    ></textarea>
                  </div>
                  <div class="buttons-container-mic">
                    <button
                      v-if="isDictatingCampo !== 'descripcion'"
                      @click="startDictation('descripcion')"
                      type="button"
                      class="btn btn-light"
                      title="Iniciar Dictado"
                    >
                      <span class="material-symbols-outlined" style="font-size: 40px; color: orangered; cursor: pointer">mic_off</span>
                    </button>
                    <button
                      v-else
                      @click="stopDictation"
                      type="button"
                      class="btn btn-light"
                      title="Finalizar Dictado"
                    >
                      <span class="material-symbols-outlined" style="font-size: 40px; color: green; cursor: pointer">mic</span>
                    </button>
                  </div>
                </div>
              </div>

              <!-- Respuesta Estándar -->
              <div class="mb-3">
                <div class="row">
                  <div class="col-12">
                    <label for="respuestaDescripcion" class="form-label">Respuesta Estándar</label>
                    <textarea
                      class="form-control"
                      id="respuestaDescripcion"
                      name="respuestaDescripcion"
                      v-model="datoPlaDetObs.respuestaDescripcion"
                      style="text-transform: uppercase"
                      disabled
                    ></textarea>
                  </div>
                </div>
              </div>

              <!-- Respuesta Complementaria -->
              <div class="mb-3">
                <div class="row">
                  <div class="col-12">
                    <label for="respuesta" class="form-label">Respuesta Complementaria</label>
                    <textarea
                      class="form-control"
                      id="respuesta"
                      name="respuesta"
                      v-model="datoPlaDetObs.respuesta"
                      style="text-transform: uppercase"
                      disabled
                    ></textarea>
                  </div>
                </div>
              </div>
            </div>
          </form>
          <div class="modal-footer">
            <button
              type="submit"
              class="btn btn-light"
              @click.prevent="guardarPlaDetObs"
              v-if="btnCrear_det && p_procesoAM == 1"
              title="Guardar"
            >
              <i class="material-icons" style="font-size: 32px; color: blue; cursor: pointer">save</i>
              Guardar
            </button>
            <button
              type="submit"
              class="btn btn-light"
              @click.prevent="actualizarPlaDetObs"
              v-if="btnEditar_det && p_procesoAM == 1"
              title="Actualizar"
            >
              <i class="material-icons" style="font-size: 32px; color: blue; cursor: pointer">update</i>
              Actualizar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/services/api";
import SpeechDictation from "@/modules/microfono.js";
import * as bootstrap from "bootstrap";
import Swal from "sweetalert2";

export default {
  data() {
    return {
      // Master
      planilladets:    [],
      datoPlanillaDet: {},
      titulo:          "",
      btnCrear:        false,
      btnEditar:       false,
      p_idTramite:     0,
      p_estadoTramite: "",
      p_idPlanillaDet: "",
      p_tipo:          "",
      p_tipoConsulta:  "",
      planillas:       [],
      elementos:       [],
      // Details
      pladetobss:         [],
      datoPlaDetObs:      {},
      btnCrear_det:       false,
      btnEditar_det:      false,
      elementosPorPagina: 10,
      datosPaginados:     [],
      paginaActual:       1,
      observacions:       [],
      modalWindow:        true,
      p_procesoAM:        0,
      sinResultados:      false,
      // ── Ordenamiento ──────────────────────────────────────
      campoOrden:         'idPlaDetObs',
      ascendente:         false,
      // ── Filtros de columna ─────────────────────────────────
      filtroObsEstandar:  '',
      filtroDescripcion:  '',
      // ── Filtro selector modal ──────────────────────────────
      filtroObservaciones: "",
      mostrarLista:        false,
      debounceTimer:       null,
      // Misc
      dictation:           new SpeechDictation(),
      isDictatingCampo:    null,
      idEmpresa:           0,
      isModalOpen:         false,
      modalInstance:       null,
      verReportes:         0,
    };
  },

  computed: {
    // ── Registros filtrados y ordenados ───────────────────────
    pladetobsOrdenados() {
      const campo = this.campoOrden;

      let lista = this.pladetobss.filter(p => {
        const obs = this.filtroObsEstandar
          ? String(p.observacionDescripcion ?? '').toLowerCase().includes(this.filtroObsEstandar.toLowerCase())
          : true;
        const desc = this.filtroDescripcion
          ? String(p.descripcion ?? '').toLowerCase().includes(this.filtroDescripcion.toLowerCase())
          : true;
        return obs && desc;
      });

      return lista.sort((a, b) => {
        let va = a[campo] ?? '';
        let vb = b[campo] ?? '';
        if (campo === 'idPlaDetObs') {
          const na = parseInt(va, 10), nb = parseInt(vb, 10);
          if (!isNaN(na) && !isNaN(nb)) return this.ascendente ? na - nb : nb - na;
        }
        const cmp = String(va).localeCompare(String(vb), 'es');
        return this.ascendente ? cmp : -cmp;
      });
    },

    // ── Páginas visibles con puntos suspensivos ────────────────
    paginasVisibles() {
      const total  = this.totalPaginas();
      const actual = this.paginaActual;
      const delta  = 2;
      const rango  = [];
      for (let i = Math.max(2, actual - delta); i <= Math.min(total - 1, actual + delta); i++) {
        rango.push(i);
      }
      if (rango.length && rango[0] > 2)                        rango.unshift('...');
      if (rango.length && rango[rango.length - 1] < total - 1) rango.push('...');
      const paginas = [1];
      rango.forEach(p => paginas.push(p));
      if (total > 1) paginas.push(total);
      return paginas;
    },

    // ── Observación seleccionada (preview modal) ───────────────
    observacionSeleccionada() {
      if (!this.datoPlaDetObs.idObservacion) return null;
      return this.observacions.find(o => o.idObservacion === this.datoPlaDetObs.idObservacion) || null;
    },

    // ── Lista filtrada del modal ───────────────────────────────
    observacionesFiltradas() {
      const texto = this.filtroObservaciones.toLowerCase().trim();
      if (!texto) return this.observacions;
      return this.observacions.filter(obs =>
        (obs.descripcion?.toLowerCase() || '').includes(texto)
      );
    },
  },

  mounted() {
  const q = this.$route.query;
  if (q.idPlanillaDet) {
    this.p_idTramite     = Number(q.idTramite);
    this.p_estadoTramite = q.estadoTramite;
    this.p_idPlanillaDet = Number(q.idPlanillaDet);
    this.p_tipo          = q.tipo;
    this.p_procesoAM     = Number(q.procesoAM);
    this.p_tipoConsulta  = q.tipoConsulta;
  } else {
    const data = JSON.parse(sessionStorage.getItem('observacionesData'));
    if (data) {
      this.p_idTramite     = data.idTramite;
      this.p_estadoTramite = data.estadoTramite;
      this.p_idPlanillaDet = data.idPlanillaDet;
      this.p_tipo          = data.tipo;
      this.p_procesoAM     = data.procesoAM;
      this.p_tipoConsulta  = data.tipoConsulta;
    }
  }
    this.idEmpresa = window.sessionStorage.getItem('idEmpresa');
    this.abrirEditar(this.p_idPlanillaDet);
    this.verReportes = window.sessionStorage.getItem("verReportes");

    this.getDataPaginaTodos(1);
    this.fetchObservacions();
    const modalElement = document.getElementById('ventanaModal');
    if (modalElement) {
      this.modalInstance = new bootstrap.Modal(modalElement, {
        backdrop: 'static',
        keyboard: false,
      });
    }
    this.limpiarBackdrops();
    document.addEventListener('click', this.onClickFuera);
  },

  beforeUnmount() {
    document.removeEventListener('click', this.onClickFuera);
  },

  methods: {
    // ── Ordenamiento ──────────────────────────────────────────
    ordenarPor(campo) {
      if (this.campoOrden === campo) {
        this.ascendente = !this.ascendente;
      } else {
        this.campoOrden = campo;
        this.ascendente = true;
      }
      this.aplicarPaginacion(1);
    },

    iconOrden(campo) {
      if (this.campoOrden !== campo) return '⇅';
      return this.ascendente ? '↑' : '↓';
    },

    // ── Paginación ────────────────────────────────────────────
    totalPaginas() {
      return Math.max(1, Math.ceil(this.pladetobsOrdenados.length / this.elementosPorPagina));
    },

    aplicarPaginacion(noPagina) {
      this.paginaActual   = noPagina;
      const ini           = (noPagina - 1) * this.elementosPorPagina;
      this.datosPaginados = this.pladetobsOrdenados.slice(ini, ini + this.elementosPorPagina);
    },

    getPreviousPage() {
      if (this.paginaActual > 1) this.aplicarPaginacion(this.paginaActual - 1);
    },

    getNextPage() {
      if (this.paginaActual < this.totalPaginas()) this.aplicarPaginacion(this.paginaActual + 1);
    },

    // ── Carga de datos ────────────────────────────────────────
    getDataPaginaTodos(noPagina) {
      this.sinResultados = false;
      api
        .get(`/vwpladetobss/idplanilladet-tipo/${this.p_idPlanillaDet}/${this.p_tipo}`)
        .then(response => {
          this.pladetobss = Array.isArray(response.data) ? response.data.reverse() : [];
          this.aplicarPaginacion(noPagina);
          this.sinResultados = this.pladetobss.length === 0;
        });
    },

    // ── Selector de observaciones (modal) ─────────────────────
    onFiltroInput() {
      clearTimeout(this.debounceTimer);
      this.debounceTimer = setTimeout(() => { this.mostrarLista = true; }, 250);
    },

    limpiarFiltroObservaciones() {
      this.filtroObservaciones = '';
      this.mostrarLista        = false;
    },

    seleccionarObservacion(obs) {
      this.datoPlaDetObs       = { ...this.datoPlaDetObs, idObservacion: obs.idObservacion };
      this.filtroObservaciones = obs.descripcion;
      this.mostrarLista        = false;
    },

    onClickFuera(event) {
      const card = this.$el.querySelector?.('.obs-selector-card');
      if (card && !card.contains(event.target)) this.mostrarLista = false;
    },

    resaltarTexto(texto, termino) {
      if (!texto) return '';
      const escapado = texto.replace(/[&<>"']/g, c =>
        ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c])
      );
      if (!termino?.trim()) return escapado;
      const re = new RegExp(`(${termino.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')})`, 'gi');
      return escapado.replace(re, '<mark class="obs-highlight">$1</mark>');
    },

    // ── Master ────────────────────────────────────────────────
    abrirEditar(idPlanillaDet) {
      if (idPlanillaDet != null) {
        api.get('/vwplanilladets/' + idPlanillaDet).then(resp => {
          this.datoPlanillaDet = resp.data;
        });
      }
      this.titulo    = 'Editar';
      this.btnCrear  = false;
      this.btnEditar = true;
    },

    // ── Dictado ───────────────────────────────────────────────
    startDictation(campo) {
      this.isDictatingCampo = campo;
      this.dictation.startDictation(transcript => {
        this.datoPlaDetObs[campo] = transcript;
      }, this.datoPlaDetObs[campo]);
    },

    stopDictation() {
      this.isDictatingCampo = null;
      this.dictation.stopDictation();
    },

    // ── Modal ─────────────────────────────────────────────────
    cerrarModal() {
      this.isModalOpen         = false;
      this.filtroObservaciones = '';
      this.mostrarLista        = false;
      if (this.modalInstance) this.modalInstance.hide();
      document.querySelectorAll('.modal-backdrop').forEach((el, i) => {
        if (i > 0) el.remove();
      });
    },

    abrirModalCrear() {
      this.modalWindow   = true;
      this.datoPlaDetObs = {};
      this.titulo        = 'Crear';
      this.btnCrear_det  = true;
      this.btnEditar_det = false;
      this.isModalOpen   = true;
      this.mostrarLista  = true;
      if (this.modalInstance) this.modalInstance.show();
    },

    abrirModalEditar(idPlaDetObs) {
      this.modalWindow   = true;
      this.btnCrear_det  = false;
      this.btnEditar_det = true;
      this.isModalOpen   = true;
      if (idPlaDetObs != null) {
        api.get('/vwpladetobss/' + idPlaDetObs).then(resp => {
          this.datoPlaDetObs = resp.data;
          const obs = this.observacions.find(o => o.idObservacion === resp.data.idObservacion);
          if (obs) this.filtroObservaciones = obs.descripcion;
        });
      }
      this.titulo = 'Editar';
      if (this.modalInstance) this.modalInstance.show();
    },

    // ── CRUD ──────────────────────────────────────────────────
    async guardarPlaDetObs() {
      if (!this.datoPlaDetObs.idObservacion) {
        Swal.fire({ icon: 'warning', title: 'Ingrese una observación', text: 'Debe seleccionar una observación estándar' });
        return;
      }
      try {
        this.datoPlaDetObs.idPlanillaDet = this.datoPlanillaDet.idPlanillaDet;
        this.datoPlaDetObs.idUsuarioReg  = window.sessionStorage.getItem('idUsuario');
        await api.post('/pladetobss', this.datoPlaDetObs);
        Swal.fire({ title: '¡Correcto!', text: 'Observación creada exitosamente.', icon: 'success', confirmButtonText: 'Aceptar' });
        this.getDataPaginaTodos(this.paginaActual);
        this.cerrarModal();
      } catch {
        Swal.fire({ title: 'Error', text: '¡Inténtelo de nuevo!', icon: 'error', confirmButtonText: 'Aceptar' });
        this.cerrarModal();
      }
    },

    async actualizarPlaDetObs() {
      if (!this.datoPlaDetObs.idObservacion) {
        Swal.fire({ icon: 'warning', title: 'Ingrese una observación', text: 'Debe seleccionar una observación estándar' });
        return;
      }
      try {
        this.datoPlaDetObs.idUsuarioAct = window.sessionStorage.getItem('idUsuario');
        await api.post('/pladetobss', this.datoPlaDetObs);
        Swal.fire({ title: '¡Correcto!', text: 'Observación actualizada exitosamente.', icon: 'success', confirmButtonText: 'Aceptar' });
        this.getDataPaginaTodos(this.paginaActual);
        this.cerrarModal();
      } catch (error) {
        Swal.fire({ title: 'Error', text: 'Inténtelo de nuevo.', icon: 'error', confirmButtonText: 'Aceptar' });
        if (error.response?.data?.errors) {
          Object.values(error.response.data.errors).forEach(e =>
            Swal.fire({ title: 'Error', text: String(e), icon: 'error', confirmButtonText: 'Aceptar' })
          );
        }
        this.cerrarModal();
      }
    },

    async deletePlaDetObs(idPlaDetObs) {
      try {
        await api.delete('/pladetobss/' + idPlaDetObs);
        this.getDataPaginaTodos(this.paginaActual);
      } catch {
        Swal.fire({ title: 'Error', text: 'No se pudo eliminar.', icon: 'error', confirmButtonText: 'Aceptar' });
      }
    },

    fetchObservacions() {
      api
        .get(`/vwobservacions/idempresa-tipo/${this.idEmpresa}/${this.p_tipo}`)
        .then(response => { this.observacions = response.data; })
        .catch(error => { console.error('Error fetching observacions:', error); });
    },

    limpiarBackdrops() {
      document.querySelectorAll('.modal-backdrop').forEach(el => el.remove());
    },

irAPlanillaPopup(idPlanilla) {
  const params = new URLSearchParams({
    idTramite:     this.p_idTramite,
    idServicio:    1,
    estadoTramite: this.p_estadoTramite,
    idPlanilla,
    tipoConsulta:  this.p_tipoConsulta,
  });
  this.$router.push(`/planillaformpopup?${params.toString()}`);
},
  },
};
</script>

<style scoped>
.th-sort {
  cursor: pointer;
  user-select: none;
  white-space: nowrap;
}
.th-sort:hover {
  background-color: #3d5166;
}
.table-hover tbody tr {
  cursor: pointer;
}
.modal-backdrop.show + .modal-backdrop { display: none !important; }
.modal          { z-index: 1055; }
.modal-backdrop { z-index: 1040; }

/* ── Selector de observaciones ─────────────────────────── */
.obs-selector-card {
  border: 1px solid #dee2e6;
  border-radius: 10px;
  padding: 14px 16px;
  background: #f8f9fa;
  position: relative;
}
.obs-selector-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}
.obs-selector-title {
  font-weight: 600;
  font-size: 0.93rem;
  color: #343a40;
  display: flex;
  align-items: center;
  gap: 4px;
}
.obs-icon { font-size: 18px !important; color: #0d6efd; }
.obs-count-badge {
  font-size: 0.75rem;
  background: #0d6efd;
  color: #fff;
  border-radius: 20px;
  padding: 2px 10px;
  font-weight: 500;
}
.obs-search-bar {
  display: flex;
  align-items: center;
  background: #fff;
  border: 1px solid #ced4da;
  border-radius: 8px;
  padding: 0 10px;
  transition: border-color 0.2s, box-shadow 0.2s;
}
.obs-search-bar:focus-within {
  border-color: #0d6efd;
  box-shadow: 0 0 0 3px rgba(13, 110, 253, 0.15);
}
.obs-search-icon { font-size: 20px !important; color: #6c757d; margin-right: 6px; }
.obs-search-input {
  flex: 1;
  border: none;
  outline: none;
  padding: 8px 0;
  font-size: 0.92rem;
  background: transparent;
}
.obs-clear-btn {
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  color: #6c757d;
  display: flex;
  align-items: center;
  transition: color 0.15s;
}
.obs-clear-btn:hover { color: #dc3545; }
.obs-selected-preview {
  display: flex;
  align-items: center;
  gap: 8px;
  background: #e7f1ff;
  border: 1px solid #b6d4fe;
  border-radius: 8px;
  padding: 7px 12px;
  margin-top: 8px;
  font-size: 0.87rem;
  color: #084298;
}
.obs-selected-text { color: #343a40; }
.obs-results-list {
  max-height: 220px;
  overflow-y: auto;
  border: 1px solid #dee2e6;
  border-radius: 8px;
  margin-top: 8px;
  background: #fff;
  box-shadow: 0 4px 12px rgba(0,0,0,0.08);
  scrollbar-width: thin;
  scrollbar-color: #adb5bd #f8f9fa;
}
.obs-results-list::-webkit-scrollbar { width: 6px; }
.obs-results-list::-webkit-scrollbar-thumb { background: #adb5bd; border-radius: 4px; }
.obs-result-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 9px 14px;
  cursor: pointer;
  border-bottom: 1px solid #f1f3f5;
  border-left: 3px solid transparent;
  transition: background 0.12s, border-color 0.12s;
  font-size: 0.88rem;
}
.obs-result-item:last-child { border-bottom: none; }
.obs-result-item:hover {
  background: #f0f4ff;
  border-left-color: #0d6efd;
}
.obs-result-item--selected {
  background: #e7f1ff;
  border-left-color: #0d6efd;
}
.obs-result-desc { flex: 1; line-height: 1.35; color: #212529; }
.obs-result-check { flex-shrink: 0; }
:deep(.obs-highlight) {
  background: #fff3cd;
  color: #664d03;
  border-radius: 2px;
  padding: 0 1px;
  font-weight: 600;
}
.obs-empty {
  text-align: center;
  padding: 20px;
  color: #6c757d;
  font-size: 0.88rem;
}
.obs-empty p { margin: 6px 0 0; }
</style>

<style src="@/assets/css/microfono.css" scoped></style>